import * as actions from "./actions";
import {SET_BUILD} from './types';
import * as getters from "./getters";

const state = {
  build: null
};

const mutations = {
  [SET_BUILD](state, build) {
    state.build = build;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};